import { useParams, Link } from "react-router-dom";
import { useGetSaleByIdQuery } from "./salesApiSlice";
import EditSaleForm from "./EditSaleForm";

export default function EditSale() {
  const { id } = useParams();
  const { data: sale, isLoading, isFetching, isError, error } = useGetSaleByIdQuery(id);

  return (
    <section className="p-6 space-y-6">
      {/* Header */}
      <header className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-gray-900">Edit Sale</h1>
          <p className="text-sm text-gray-500">Update title, dates, status, and description.</p>
        </div>
        <Link
          to="/dash/sales"
          className="rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
        >
          Back to list
        </Link>
      </header>

      {/* States */}
      {isLoading && (
        <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">Loading…</div>
      )}
      {isError && (
        <div className="rounded-2xl border border-rose-200 bg-rose-50 p-4 text-sm text-rose-700">
          {error?.data?.message || "Failed to load sale."}
        </div>
      )}

      {/* Form */}
      {sale && <EditSaleForm sale={sale} />}
    </section>
  );
}
